import { createReducer, on } from '@ngrx/store';

import { ICustomer } from '@ruby/modules/customer-select/models/customer.interface';
import { IThirdPartySearchCompany } from '@ruby/modules/third-party/models/third-party.interface';
import * as ThirdPartyCompaniesActions from '@ruby/modules/third-party/store/actions/third-party-companies.actions';
import { IError } from '@ruby/shared/models/request/error.interface';

export const featureKey = 'companies';

export interface State {
  loading: boolean;
  companies: Array<IThirdPartySearchCompany>;
  customerCompany?: ICustomer;
  providerCompany?: IThirdPartySearchCompany;
  error?: IError;
}

export const initialState: State = {
  loading: false,
  companies: [],
  customerCompany: undefined,
  providerCompany: undefined,
  error: undefined
};

export const reducer = createReducer(
  initialState,
  on(ThirdPartyCompaniesActions.searchCompanies, (state, action) => ({
    ...state,
    loading: true,
    companies: [],
    error: undefined
  })),
  on(ThirdPartyCompaniesActions.searchCompaniesSuccess, (state, action) => ({
    ...state,
    loading: false,
    companies: action.data
  })),
  on(ThirdPartyCompaniesActions.searchCompaniesFailure, (state, action) => ({
    ...state,
    loading: false,
    error: action.error
  })),
  on(ThirdPartyCompaniesActions.setCustomerCompany, (state, action) => ({
    ...state,
    customerCompany: action.data
  })),
  on(ThirdPartyCompaniesActions.setCompanyProvider, (state, action) => ({
    ...state,
    providerCompany: action.data
  })),
  on(ThirdPartyCompaniesActions.requestEid, (state, action) => ({
    ...state,
    loading: true,
    error: undefined
  })),
  on(ThirdPartyCompaniesActions.requestEidSuccess, (state, action) => ({
    ...state,
    loading: false
  })),
  on(ThirdPartyCompaniesActions.requestEidFailure, (state, action) => ({
    ...state,
    loading: false,
    error: action.error
  })),
  on(ThirdPartyCompaniesActions.clearCompanyProvider, (state, action) => ({
    ...state,
    providerCompany: undefined
  })),
  on(ThirdPartyCompaniesActions.clearSearch, (state, action) => ({
    ...state,
    providerCompany: undefined,
    companies: []
  })),
  on(ThirdPartyCompaniesActions.clearCompanies, () => initialState)
);
